/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Top_Rated_DescriptionInputs */

const en_directory_hubs_top_rated_description = /** @type {(inputs: Directory_Hubs_Top_Rated_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Community favorites ranked by rating and review activity.`)
};

const zh_directory_hubs_top_rated_description = /** @type {(inputs: Directory_Hubs_Top_Rated_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据评分与评价活跃度排列的社区优选产品。`)
};

/**
* | output |
* | --- |
* | "Community favorites ranked by rating and review activity." |
*
* @param {Directory_Hubs_Top_Rated_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_top_rated_description = /** @type {((inputs?: Directory_Hubs_Top_Rated_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Top_Rated_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_top_rated_description(inputs)
	return zh_directory_hubs_top_rated_description(inputs)
});
export { directory_hubs_top_rated_description as "directory.hubs.top-rated.description" }